/*@flow*/
import isType from './isType';
import type { TypeT } from './types';

// returns true if x is an instance of type
export default function is(x: any, type: TypeT<*>): %checks {
  // type should be a class constructor
  return isType(type) ? type.is(x) : x instanceof type;
}
